module.exports = __webpack_public_path__ + "img/bid_img2.685ecfeb.jpg";